/**
 * App-Web Extensions
 *
 * This file imports both:
 * 1. Platform-agnostic extensions from switch-core (String, Number)
 * 2. Browser-specific extensions (Blob, Canvas, web-specific String methods)
 *
 * Other platforms (iOS, Android) should import switch-core extensions directly
 * and provide their own platform-specific implementations.
 */

const tag = "[extensions]";

// Platform-agnostic extensions from switch-core (String, Number)
import "../../core_bridge/switch-core/extensions";

// Browser-specific String extensions (toBlob, convertToRemoteStickerUrl, etc.)
import "./string";

// Browser-specific Number extensions (currently just re-exports core)
import "./number";

// Browser-specific Blob extensions (toUint8Array, calculateMD5)
import "./blob";

// Browser-specific Canvas extensions (cropCanvasToSquare)
import "./canvas";

console.log(tag, "all extensions loaded");
